"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const isAnalyticsChannel = () => window.location.hostname === 'analytics.icis.com';
var _default = exports.default = isAnalyticsChannel;